import { LayoutContext } from 'contexts/LayoutContext';
import React, { useContext } from 'react';
import { useModalView } from '@/design-system/components/modal/useModalView.hook';

import { ChangeATMPINStackRoutes, ChangeATMPINStackScreenProps } from './type';
import { ChangeATMPINWebOneScreen } from './ChangeATMPINWebOne.screen';
import { ChangeATMPINNativeOneScreen } from './ChangeATMPINNativeOne.screen';

export const ChangeATMPINConfirm: React.FC<ChangeATMPINStackScreenProps<ChangeATMPINStackRoutes.Confirm>> = ({ navigation, route }) => {
  const { onLayout, data, account, tab, record, func, onReturnData } = route.params;
  const layout = useContext(LayoutContext);
  const onGoBack = () => {
    navigation.goBack();
  };
  const { useModalProps, closeModal } = useModalView({});
  if (layout.isMobile) {
    return (
      <ChangeATMPINNativeOneScreen
        onClose={onGoBack}
        onLayout={onLayout}
        data={data}
        account={account}
        tab={tab}
        record={record}
        func={func}
        onReturnData={onReturnData}
      />
    );
  }

  return (
    <ChangeATMPINWebOneScreen
      onClose={closeModal}
      onLayout={onLayout}
      data={data}
      account={account}
      tab={tab}
      record={record}
      func={func}
      onReturnData={onReturnData}
    />
  );
};
